import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  titleSectionProps: {
    hideBottomPadding: true,
    hideTopPadding: true,
    title: 'offers for you'
  },
  maxItemsToShow: 3,
  buttonProps: {
    title: '4 MORE OFFERS',
    iconName: 'DownChevronIcon',
    expandedTitle: 'SHOW LESS OFFERS',
    expandedIconName: 'UpChevronIcon'
  },
  calloutProps: {
    state: 'error',
    iconName: 'InfoIcon',
    title: 'payment unsuccessful',
    description: "this could be due to the payment gateway failure. don't worry, any money deducted will be refunded in 3-5 business days."
  },
  cardTitleProps: {
    title: 'RETRY PAY VIA'
  },
  data: [{
    orderSummaryCardProps: {
      subTitle: 'bill payment • 7303292767',
      priceDetails: {
        price: '₹1,299.00',
        oldPrice: 'GST incl.',
        isOldPriceStriked: false
      },
      removeCardBorderRadius: true,
      title: 'amount payable'
    }
  }, {
    selectionListProps: {
      variation: 'full-size',
      id: '1',
      style: {
        backgroundColor: '#f4f5ff'
      },
      buttonProps: {
        buttonType: 'primary',
        size: 'md',
        theme: 'light',
        title: 'pay ₹2,299',
        controlState: 'none'
      },
      isSelected: false,
      linkListItemProps: {
        actionType: 'radio',
        roundedCorners: true,
        noPadding: true,
        heading: 'Paytm',
        style: {
          backgroundColor: '#f4f5ff',
          paddingHorizontal: 16,
          paddingTop: 8
        },
        avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
      }
    }
  }, {
    selectionListProps: {
      variation: 'full-size',
      id: '2',
      style: {
        backgroundColor: '#f4f5ff'
      },
      buttonProps: {
        buttonType: 'primary',
        size: 'md',
        theme: 'light',
        title: 'pay ₹2,299',
        controlState: 'none'
      },
      isSelected: false,
      linkListItemProps: {
        actionType: 'radio',
        roundedCorners: true,
        noPadding: true,
        heading: 'Paytm',
        style: {
          backgroundColor: '#f4f5ff',
          paddingHorizontal: 16,
          paddingTop: 8
        },
        avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
      }
    }
  }, {
    selectionListProps: {
      variation: 'full-size',
      id: '3',
      style: {
        backgroundColor: '#f4f5ff'
      },
      buttonProps: {
        buttonType: 'primary',
        size: 'md',
        theme: 'light',
        title: 'pay ₹2,299',
        controlState: 'none'
      },
      isSelected: false,
      linkListItemProps: {
        actionType: 'radio',
        roundedCorners: true,
        noPadding: true,
        heading: 'Paytm',
        style: {
          backgroundColor: '#f4f5ff',
          paddingHorizontal: 16,
          paddingTop: 8
        },
        avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
      }
    },
    cardTitleProps: {
      color: 'black',
      imageProps: {
        uri: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/checkout/xxhdpi/airtel_upi.png'
      },
      onPressMetaData: {
        id: 'card title press'
      },
      title: 'LINKED BANK A/C'
    }
  }, {
    cardTitleProps: {
      onPressMetaData: {
        id: 'card title press'
      },
      color: 'black',
      iconName: 'CategoriesIcon',
      actionIconName: 'RightChevronIcon',
      title: 'select other payment options',
      showActionCtaWithCheveron: true,
      actionTypes: 'icon'
    }
  }]
}, getTestId('OfferListWidgetContainer'));